import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  ref: "modalRef",
  class: "modal-content neon"
}
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "input" }
const _hoisted_4 = { class: "actions" }
const _hoisted_5 = { class: "btn" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_input = _resolveComponent("app-input")!
  const _component_app_button = _resolveComponent("app-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createElementVNode("span", null, _toDisplayString(_ctx.t('newFolder')), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_app_input, {
        modelValue: _ctx.folderName,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.folderName) = $event)),
        "is-focused": true,
        "is-label": false,
        placeholder: "nameFolder"
      }, null, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", {
        class: "btn",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
      }, [
        _createVNode(_component_app_button, {
          title: "cancel",
          severity: "error",
          onClick: _ctx.close
        }, null, 8, ["onClick"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_app_button, {
          disabled: !_ctx.folderName,
          title: "ok",
          severity: "info",
          onClick: _ctx.setName
        }, null, 8, ["disabled", "onClick"])
      ])
    ])
  ], 512))
}